import { Link } from "react-router-dom";
import { t } from "../../i18n";

export function ProductRelatedSection({ relatedProducts, scrollRelatedProducts }) {
  if (!relatedProducts.length) {
    return null;
  }

  return (
    <section className="product-related-section" aria-label={t("pdRelatedAria")}>
      <div className="product-related-head">
        <div>
          <h2>{t("pdRelatedTitle")}</h2>
          <p>{t("pdRelatedSubtitle")}</p>
        </div>
        <div className="product-related-controls">
          <button type="button" aria-label={t("pdRelatedPrevAria")} onClick={() => scrollRelatedProducts(-1)}>‹</button>
          <button type="button" aria-label={t("pdRelatedNextAria")} onClick={() => scrollRelatedProducts(1)}>›</button>
        </div>
      </div>

      <div ref={relatedProducts.trackRef} className="product-related-track">
        {relatedProducts.items.map((item) => (
          <article key={`related-${item.id}`} className="product-related-card">
            <Link to={`/products/${item.id}`} state={{ productTitle: item.name }} className="image-link" aria-label={item.name}>
              <img src={item.imageUrl} alt={item.name} loading="lazy" />
            </Link>
            <div className="product-related-card-body">
              <p className="product-related-category">{item.category}</p>
              <h3>
                <Link to={`/products/${item.id}`} state={{ productTitle: item.name }}>{item.name}</Link>
              </h3>
              <p>{item.description}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export function ProductSampleModal({
  open,
  onClose,
  product,
  activeImage,
  modalSummaryAttributes,
  sampleQuantity,
  setSampleQuantity,
  sampleForm,
  onFieldChange,
  onSubmit,
  sampleSent,
  submitPending,
  submitError
}) {
  if (!open) {
    return null;
  }

  return (
    <div className="product-sample-modal-backdrop" onClick={onClose}>
      <div className="product-sample-modal" onClick={(event) => event.stopPropagation()}>
        <div className="product-sample-modal-head">
          <div>
            <h2>{t("pdSampleContactTitle")}</h2>
            <p>
              {t("pdSampleContactDesc")}
            </p>
          </div>
          <button type="button" className="product-sample-close" onClick={onClose} aria-label={t("pdSampleCloseAria")}>
            ×
          </button>
        </div>

        <div className="product-sample-modal-body">
          <section className="product-sample-summary">
            <div className="product-sample-summary-head">
              <span>{t("pdSampleSummaryProduct")}</span>
              <span>{t("pdSampleSummaryQuantity")}</span>
            </div>
            <article className="product-sample-item">
              <img src={activeImage || product.imageUrl} alt={product.name} loading="lazy" />
              <div className="product-sample-item-copy">
                <h3>
                  <Link to={`/products/${product.id}`} className="product-sample-item-title" onClick={onClose}>
                    {product.name}
                  </Link>
                </h3>
                {modalSummaryAttributes.map((item) => (
                  <p key={`sample-${item.label}`}>
                    <strong>{item.label}:</strong> {item.values.join(", ")}
                  </p>
                ))}
              </div>
              <div className="product-sample-qty">
                <button type="button" onClick={() => setSampleQuantity((current) => Math.max(1, current - 1))}>−</button>
                <span>{sampleQuantity}</span>
                <button type="button" onClick={() => setSampleQuantity((current) => current + 1)}>+</button>
              </div>
            </article>
          </section>

          <aside className="product-sample-form-wrap">
            <form className="product-sample-form" onSubmit={onSubmit}>
              <label>
                <span>{t("pdFormFullName")}</span>
                <input
                  value={sampleForm.fullName}
                  onChange={(event) => onFieldChange("fullName", event.target.value)}
                  placeholder={t("pdFormFullNamePlaceholder")}
                  required
                />
              </label>
              <label>
                <span>{t("pdFormEmail")}</span>
                <input
                  type="email"
                  value={sampleForm.email}
                  onChange={(event) => onFieldChange("email", event.target.value)}
                  placeholder={t("pdFormEmailPlaceholder")}
                  required
                />
              </label>
              <label>
                <span>{t("pdFormWhatsapp")}</span>
                <input
                  value={sampleForm.whatsapp}
                  onChange={(event) => onFieldChange("whatsapp", event.target.value)}
                  placeholder={t("pdFormWhatsappPlaceholder")}
                  required
                />
              </label>
              <label>
                <span>{t("pdFormCompany")}</span>
                <input
                  value={sampleForm.company}
                  onChange={(event) => onFieldChange("company", event.target.value)}
                  placeholder={t("pdFormCompanyPlaceholder")}
                />
              </label>
              <label>
                <span>{t("pdFormRequiredQuantity")}</span>
                <input
                  value={sampleForm.requiredQuantity}
                  onChange={(event) => onFieldChange("requiredQuantity", event.target.value)}
                  placeholder={t("pdFormRequiredQuantityPlaceholder")}
                />
              </label>
              <label>
                <span>{t("pdFormMessage")}</span>
                <textarea
                  rows={5}
                  value={sampleForm.message}
                  onChange={(event) => onFieldChange("message", event.target.value)}
                  placeholder={t("pdFormMessagePlaceholder")}
                  required
                />
              </label>
              <button className="button product-sample-submit" type="submit" disabled={submitPending}>
                {submitPending ? t("pdFormSending") : t("pdFormSendMessage")}
              </button>
              {sampleSent ? <p className="state">{t("pdFormInquirySuccess")}</p> : null}
              {submitError ? <p className="state error">{submitError}</p> : null}
            </form>
          </aside>
        </div>
      </div>
    </div>
  );
}
